// example code to handle the user's selection
const grid3Button = document.querySelector(".facets-grid-3");
const grid5Button = document.querySelector(".facets-grid-5");
const facetsContainer = document.getElementById("main-collection-filters") || document.getElementById
("main-search-filters");
const productGrid = document.getElementById("ProductGridContainer");

// Function to set a cookie with the selected view
function setViewCookie(view) {
  document.cookie = `selectedView=${view}; path=/`;
}

function getViewFromCookie() {
  const name = "selectedView=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return null;
}

grid3Button.addEventListener("click", function() {
  if (facetsContainer.dataset.grid != "3") {
    facetsContainer.dataset.grid = "3";
    setViewCookie("grid3");
  }
});

grid5Button.addEventListener("click", function() {
  if (facetsContainer.dataset.grid != "5") {
    facetsContainer.dataset.grid = "5";
    setViewCookie("grid5");
  }
});

const selectedView = getViewFromCookie();
if (selectedView == "grid5") {
    facetsContainer.dataset.grid = "5";
//   productGrid.classList.remove("visually-hidden");
} 
//else {
//   productGrid.classList.remove("visually-hidden");
// }